import React ,{useState, useContext, useReducer} from 'react';
import { Link } from "react-router-dom";
import MenuContext from '../../components/Context/MenuContext';
import { slide as Menu } from 'react-burger-menu'

function HamburgerMenu(props) {
    const context = useContext(MenuContext)
    const [isOpen, setIsOpen] = useState(false)
    return (

        <div className="d-md-none">
            <Menu disableAutoFocus isOpen={false}>
                {context.state && context.state.menuLink.map((menu,i)=>{
                    return(
                        <a hidden={!menu.visible} key={i} href={"/"+menu.to} style={{marginBottom:"15px",textDecoration:"none",color:"white"}} 
                        onClick={(e)=>{context.dispatch({type:"GOTO",payload:menu.position})}}>
                            <span>{menu.text}</span>
                        </a>
                    )
                })}
            </Menu>
        </div>
    );
}

export default HamburgerMenu;